export default "__VITE_ASSET__DGmYQeFf__"